/**
 * GENERATED by scripts/generate-board-steps.ts from the committed docs/living/planner-magic-canvas/Chapter3.dc.html — DO NOT EDIT.
 * Regenerate with `npm run board:generate`; `npm run check:board-parity` fails when this file and the board disagree.
 */

import { SAGE, WARM } from "../brand";

export const BOARD_STEPS_CH3 = [
  {
    "key": "work",
    "crumb": "Your job",
    "title": "Work",
    "why": "Select what is true today — more than one can be.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "job",
            "label": "A job",
            "sub": "employed by someone else",
            "mark": "JOB",
            "color": SAGE[600]
          },
          {
            "id": "biz",
            "label": "My own business",
            "sub": "you own it, in whole or in part",
            "full": "Business name",
            "typed": true,
            "mark": "BIZ",
            "color": "#8B1E3F"
          },
          {
            "id": "self",
            "label": "Self-employed",
            "sub": "freelance, contract or gig work",
            "full": "Business name",
            "typed": true,
            "mark": "SELF",
            "color": "#A3651F"
          },
          {
            "id": "role",
            "label": "Other work",
            "sub": "a board seat or casual work",
            "mark": "ROLE",
            "color": "#5B7596"
          }
        ],
        "none": {
          "label": "None of these",
          "sub": "",
          "prune": 3,
          "delta": "Noted — nothing for your executor to write to on the first day."
        }
      }
    ],
    "rowsLead": "",
    "rowsNote": "the exact name is what your executor writes to",
    "cols": "300px 280px 170px 216px",
    "headers": [
      {
        "label": "Work"
      },
      {
        "label": "The employer or organisation"
      },
      {
        "label": "Employee number"
      }
    ],
    "cells": [
      {
        "kind": "joint",
        "k": "call",
        "title": "Who is the employer or organisation?",
        "word": "Name them",
        "undo": "Not now",
        "org": true
      },
      {
        "kind": "text",
        "k": "empno",
        "ph": "If you know it"
      }
    ],
    "second": {
      "tiles": [
        "biz",
        "self"
      ],
      "rules": {
        "self": {
          "co": false,
          "ph": {
            "role": "Sole proprietor"
          }
        }
      },
      "rowsLead": "",
      "rowsNote": "",
      "cols": "150px 296px 166px 110px 182px 140px 216px",
      "headers": [
        {
          "label": "Business name"
        },
        {
          "label": "What kind"
        },
        {
          "label": "Your role"
        },
        {
          "label": "Estimated value"
        },
        {
          "label": "Who takes over"
        },
        {
          "label": "Who else owns it"
        }
      ],
      "cells": [
        {
          "kind": "picker",
          "k": "kind",
          "ph": "Choose…",
          "opts": [
            "Corporation",
            "Partnership",
            "Limited liability partnership (LLP)",
            "Professional corporation",
            "Sole proprietorship",
            "Self-employed or freelance",
            "Farm",
            "Holding company",
            "Other — type it"
          ],
          "otherLabel": "What kind"
        },
        {
          "kind": "text",
          "k": "role",
          "long": true,
          "ph": "e.g. 50% owner",
          "bigTitle": "Your role"
        },
        {
          "kind": "text",
          "k": "worth",
          "ph": "$250,000"
        },
        {
          "kind": "joint",
          "k": "takes",
          "title": "Who takes over, or knows it best?",
          "word": "Name them",
          "undo": "Nobody named"
        },
        {
          "kind": "joint",
          "k": "co",
          "title": "Who else owns it?",
          "word": "Name them",
          "undo": "I own all of it"
        }
      ]
    },
    "noteFor": {
      "own": "Naming them is what stops the business stalling while the estate is sorted out. Theirs is the first call made."
    },
    "nextNote": ""
  },
  {
    "key": "cover",
    "crumb": "Benefits from work",
    "title": "Coverage and Benefits",
    "why": "What comes with the job. Some of it stops the same day and has to be cancelled; some of it pays out to somebody.",
    "rules": {
      "hw": {
        "inst": true,
        "card": true,
        "amount": false,
        "cost": false
      },
      "ho": {
        "inst": true,
        "card": true,
        "amount": false,
        "cost": true
      },
      "hg": {
        "inst": true,
        "amount": false,
        "cost": false,
        "opts": [
          {
            "label": "Ontario Drug Benefit",
            "mark": "ODB",
            "color": "#062E5F"
          },
          {
            "label": "Trillium Drug Program",
            "mark": "TDP",
            "color": "#1F5C3A"
          },
          {
            "label": "Ontario Disability Support Program",
            "mark": "ODSP",
            "color": "#5B7596"
          },
          {
            "label": "Non-Insured Health Benefits",
            "mark": "NIHB",
            "color": "#7A6BA8"
          },
          {
            "label": "Veterans Affairs disability benefits",
            "mark": "VAC",
            "color": "#8B1E3F"
          },
          {
            "label": "A programme in another province",
            "mark": "PROV",
            "color": "#A3651F"
          },
          "Other — type it"
        ]
      },
      "shares": {
        "inst": true,
        "card": true,
        "amount": true,
        "cost": false,
        "opts": [
          {
            "label": "Computershare",
            "mark": "CPU",
            "color": "#1E3A5F"
          },
          {
            "label": "Morgan Stanley at Work",
            "mark": "MS",
            "color": "#002B51"
          },
          {
            "label": "Fidelity",
            "mark": "FID",
            "color": "#368727"
          },
          {
            "label": "E*TRADE",
            "mark": "E*",
            "color": "#6633CC"
          },
          "Other — type it"
        ]
      }
    },
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "hw",
            "label": "Health and dental — Microsoft",
            "sub": "through your job",
            "mark": "H&D",
            "color": "#3F7A75"
          },
          {
            "id": "ho",
            "label": "Health and dental (private)",
            "sub": "you pay for it yourself",
            "mark": "H&D",
            "color": "#2F7FB8"
          },
          {
            "id": "hg",
            "label": "A government programme",
            "sub": "a drug or disability programme",
            "mark": "GOV",
            "color": "#62744C"
          },
          {
            "id": "shares",
            "label": "Unvested shares or options — Microsoft",
            "sub": "RSUs, stock options, a share-purchase plan still running",
            "mark": "SHR",
            "color": "#B8860B"
          },
          {
            "id": "cother",
            "label": "Something else",
            "sub": "other employer benefits",
            "full": "What it is",
            "typed": true,
            "mark": "…",
            "color": WARM.taupe
          }
        ],
        "none": {
          "label": "None of these",
          "prune": 2
        }
      }
    ],
    "rowsLead": "Your coverage.",
    "rowsNote": "",
    "cols": "250px 214px 160px 150px 216px",
    "headers": [
      {
        "label": "Benefit"
      },
      {
        "label": "Provider, insurer or plan"
      },
      {
        "label": "Estimated value"
      },
      {
        "label": "Monthly payment"
      }
    ],
    "cells": [
      {
        "kind": "picker",
        "k": "inst",
        "ph": "Choose…",
        "opts": [
          {
            "label": "Sun Life",
            "mark": "SL",
            "color": "#F2B21C"
          },
          {
            "label": "Manulife",
            "mark": "M",
            "color": "#00A758"
          },
          {
            "label": "Canada Life",
            "mark": "CL",
            "color": "#E4002B"
          },
          {
            "label": "Desjardins Insurance",
            "mark": "D",
            "color": "#00874E"
          },
          {
            "label": "RBC Insurance",
            "mark": "RBC",
            "color": "#005DAA"
          },
          {
            "label": "iA Financial",
            "mark": "iA",
            "color": "#003DA5"
          },
          {
            "label": "Green Shield Canada",
            "mark": "GS",
            "color": "#00843D"
          },
          {
            "label": "Blue Cross",
            "mark": "BC",
            "color": "#0072CE"
          },
          {
            "label": "Ontario Drug Benefit",
            "mark": "ODB",
            "color": "#062E5F"
          },
          {
            "label": "My employer’s plan administrator",
            "mark": "ADM",
            "color": "#5B7596"
          },
          "Other — type it"
        ],
        "otherLabel": "Which one"
      },
      {
        "kind": "text",
        "k": "amount",
        "ph": "$150,000"
      },
      {
        "kind": "text",
        "k": "cost",
        "ph": "$40"
      }
    ],
    "noteFor": {},
    "nextNote": ""
  },
  {
    "key": "old",
    "pairNone": true,
    "crumb": "Past employers",
    "title": "Past Employers",
    "why": "Name any employer worth a phone call. You do not need to know what is still there — a pension, a group RRSP, shares, a policy that stayed in place, unpaid wages. That is what your executor asks them.",
    "groups": [
      {
        "cols": 3,
        "tiles": [
          {
            "id": "emp",
            "label": "An employer I have left",
            "sub": "one row per reason",
            "mark": "PAST",
            "color": "#5B7596"
          }
        ],
        "none": {
          "label": "None worth a call",
          "prune": 1
        }
      }
    ],
    "rowsLead": "Worth a call.",
    "rowsNote": "",
    "noLead": true,
    "cols": "28px 280px 260px 150px 216px",
    "headers": [
      {
        "label": ""
      },
      {
        "label": "The employer or organisation"
      },
      {
        "label": "Why to contact them"
      },
      {
        "label": "Year you left"
      }
    ],
    "cells": [
      {
        "kind": "joint",
        "k": "call",
        "title": "Who is the employer or organisation?",
        "word": "Name them",
        "undo": "Not now",
        "org": true
      },
      {
        "kind": "picker",
        "k": "why",
        "ph": "Choose…",
        "opts": [
          "A pension",
          "Money in a group RRSP or savings plan",
          "Shares or stock",
          "A policy that stayed in place",
          "Unpaid wages, a bonus or severance",
          "Not sure — just ask",
          "Other — type it"
        ],
        "otherLabel": "Why"
      },
      {
        "kind": "text",
        "k": "left",
        "ph": "e.g. 2016"
      }
    ],
    "noteFor": {},
    "nextNote": ""
  },
  {
    "key": "end3",
    "crumb": "Checkpoint",
    "title": "That is chapter three.",
    "why": "Here is what you named. Every line is a task your executor can now actually do — a pension to claim, a payment to stop, a business to keep running."
  }
];
